/* Mitlaufender Kaufkasten auf der Produktseite (22.10.2026).
   Vorher klebte der Kasten mit top: 3rem und war höher als der Bildschirm:
   Titel unter dem Header verdeckt, unten Made in Germany, Auf Lager und
   Versand-Countdown erst am Ende der linken Spalte sichtbar.
   Jetzt: Passt der Kasten unter den Header, klebt er direkt darunter.
   Ist er höher, scrollt er erst ganz durch und läuft dann mit seiner
   Unterkante am Bildschirmrand mit. Nur ab 750 px (darunter kein Mitlaufen). */
(() => {
  if (window.mseBuyboxSticky) return;
  window.mseBuyboxSticky = true;

  const GAP = 16;
  /* Bei Variantenwechsel kann Dawn den Kasten neu einsetzen, darum jedes Mal suchen */
  const findBox = () => document.querySelector('.product__info-container.product__column-sticky');
  let observed = null;

  const desktop = window.matchMedia('(min-width: 750px)');
  const headers = () => document.querySelectorAll('.shopify-section-group-header-group');

  /* Unterkante der sichtbaren, mitlaufenden Kopfbereiche (Header und Kategorieleiste) */
  const headerBottom = () => {
    let bottom = 0;
    headers().forEach((el) => {
      if (getComputedStyle(el).position !== 'sticky') return;
      const r = el.getBoundingClientRect();
      if (r.bottom > bottom && r.top < window.innerHeight) bottom = r.bottom;
    });
    return Math.max(0, Math.round(bottom));
  };

  let queued = false;
  /* Höhe ändert sich z. B. bei Variantenwechsel oder Kaufoption */
  const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(() => queue()) : null;
  const update = () => {
    queued = false;
    const box = findBox();
    if (!box) return;
    if (box !== observed && 'ResizeObserver' in window) {
      observed = box;
      resizeObserver.observe(box);
    }
    if (!desktop.matches) {
      box.style.removeProperty('top');
      return;
    }
    const below = headerBottom() + GAP;
    const fitsTop = below + box.offsetHeight + GAP <= window.innerHeight;
    const top = fitsTop ? below : window.innerHeight - box.offsetHeight - GAP;
    /* important, weil die Section „Eigenes Liquid“ in den Produktvorlagen
       top: var(--total-header-height) !important setzt (bleibt unangetastet) */
    box.style.setProperty('top', `${top}px`, 'important');
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  desktop.addEventListener('change', queue);
  update();
})();
